import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  rechercheIcone: {
    marginLeft: 15,
    marginTop: 15,
    width: 20,
    height: 20,
  },
  rechercheContainer: {
    flexDirection: 'row',
    borderWidth: 1,
    marginRight: 20,
    marginTop: 20,
    marginBottom: 5,
    marginLeft: 20,
    borderRadius: 7,
    height: 50,
  },
  rechercheTextInput: {
    marginLeft: 20,
    flex: 1,
  },
  itemSearchStyle: {
    borderWidth: 1,
    borderColor: 'rgba(224, 224, 224, 1)',
    borderRadius: 30,
    backgroundColor: '#fff',
    flexDirection: 'row',
    marginRight: 20,
    marginTop: 16,
    marginBottom: 5,
    marginLeft: 20,
    height: 50,
  },
  itemSearchIcone: {
    marginLeft: 15,
    marginTop: 15,
    width: 20,
    height: 20,
  },
  itemSearchInput: {
    marginLeft: 20,
    flex: 1,
  },
});
